define('views/components/reseller_product_compact/reseller_product_list',['require','views/base/list_view','views/components/reseller_product_compact/reseller_product','text!templates/components/reseller_product_compact/reseller_product_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/reseller_product_compact/reseller_product');

    var temp = require("text!templates/components/reseller_product_compact/reseller_product_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

